module.exports = __webpack_public_path__ + "static/media/Beu-Marketplace3.5a250387.png";